<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h5 class="pull-left">
        Heading Information
      </h5>

      <button type="button" class="btn btn-black btn-sm pull-right" @click="visible = !visible" style="margin-top: 4px">
        <i class="fa" :class="visible ? 'fa-minus' : 'fa-plus'"></i> {{ visible ? 'Hide' : 'Show' }}
      </button>

      <div class="clearfix"></div>
    </div>

    <div v-if="visible" class="panel-body form-horizontal">
      <text-form-group
          :value="orderConfirmation.order_title"
          name="order_title"
          label="Order Title"
          help-text="The order title."
          :error="getError('order_title')"
          @input="update('order_title', $event)"
      ></text-form-group>

      <text-form-group
          :value="orderConfirmation.order_number"
          name="order_number"
          label="Order Number"
          help-text="The order number."
          :error="getError('order_number')"
          @input="update('order_number', $event)"
      ></text-form-group>

      <text-form-group
          :value="orderConfirmation.purchase_order"
          name="purchase_order"
          label="Purchase Order"
          help-text="The purchase order."
          :error="getError('purchase_order')"
          @input="update('purchase_order', $event)"
      ></text-form-group>

      <TypeaheadFormGroup
          v-model="orderConfirmation.user_id"
          name="user_id"
          label="User"
          endpoint="/api/v2/users"
          :token="shared.token"
          path="data.data"
          placeholder="Search..."
          :result-label-property="row => row.attributes.full_name"
          help-text="The user that is responsible for the order confirmation."
      />

      <text-form-group
          :value="orderConfirmation.ean_number"
          name="ean_number"
          label="EAN Number"
          help-text="The EAN number of the company."
          :error="getError('ean_number')"
          @input="update('ean_number', $event)"
      ></text-form-group>

      <date-form-group
          :value="orderConfirmation.date"
          name="date"
          label="Date"
          help-text="The date of the order."
          :error="getError('date')"
          format="DD.MM.YYYY"
          @input="update('date', $event)"
      ></date-form-group>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import DateFormGroup from '@/vendor/forms/FormGroups/Horizontal/Date'
import Errors from '@/mixins/Errors'
import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'
import TypeaheadFormGroup from '@/vendor/forms/FormGroups/Horizontal/Typeahead'

export default {
  components: {DateFormGroup, SelectFormGroup, TextFormGroup, TypeaheadFormGroup},

  model: {
    prop: 'orderConfirmation',
    event: 'order-confirmation-updated'
  },

  mixins: [Errors],

  props: ['orderConfirmation', 'users'],

  data() {
    return {
      visible: false,

      shared: store
    }
  },

  computed: {
    userOptions() {
      return this.users.data.map(user => {
        return {
          value: user.id,
          label: user.attributes.full_name
        }
      })
    }
  },

  methods: {
    update(key, value) {
      this.$emit('order-confirmation-updated', {...this.orderConfirmation, [key]: value})
    }
  }
}
</script>
